import { render, staticRenderFns } from "./SideTemplate.vue?vue&type=template&id=cfa438ea&scoped=true&"
import script from "./SideTemplate.vue?vue&type=script&lang=js&"
export * from "./SideTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SideTemplate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideTemplate.vue?vue&type=style&index=1&id=cfa438ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa438ea",
  null
  
)

export default component.exports